module.exports = __webpack_public_path__ + "img/1.aceefd72.png";